import React, { useState, useEffect } from 'react'
import './WafCaptchaDia.css';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { getWafCaptcha, verifyWafCaptcha } from '../../../api/em';
import { wafCaptchaManager } from '../../../utils/wafCaptchaManager';

const WafCaptchaDia = function({ isOpen, onClose, onSuccess }) {
    const [captchaData, setCaptchaData] = useState(null);
    const [captchaValue, setCaptchaValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        if (isOpen) {
            loadCaptcha();
            setCaptchaValue('');
            setErrorMsg('');
        }
    }, [isOpen]);

    const loadCaptcha = async () => {
        setLoading(true);
        // setErrorMsg('');
        try {
            const result = await getWafCaptcha();
            if (result.err === 'ERR_OK' && result.waf && result.waf.captcha_data && result.waf.captcha_id) {
                setCaptchaData(result.waf);
            } else {
                setErrorMsg(result.errMsg || '获取验证码失败');
            }
        } catch (error) {
            setErrorMsg('获取验证码失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    const handleRefresh = () => {
        loadCaptcha();
        setCaptchaValue('');
        setErrorMsg('');
    };

    const handleSubmit = async () => {
        if (!captchaValue.trim()) {
            setErrorMsg('请输入验证码');
            return;
        }

        if (!captchaData || !captchaData.captcha_id) {
            setErrorMsg('验证码数据异常，请刷新重试');
            return;
        }

        setVerifying(true);
        setErrorMsg('');
        try {
            const targetPath = wafCaptchaManager.getTargetPath();
            const result = await verifyWafCaptcha({
                captcha_id: captchaData.captcha_id,
                captcha_value: captchaValue.trim(),
                target_path: targetPath
            });

            if (result.err === 'ERR_OK' && result.waf && result.waf.success) {
                if (onSuccess) {
                    onSuccess();
                }
                handleClose();
                window.location.reload();
            } else {
                setErrorMsg(result.errMsg || '验证失败，请重试');
                loadCaptcha();
                setCaptchaValue('');
            }
        } catch (error) {
            setErrorMsg('验证失败，请重试');
            loadCaptcha();
            setCaptchaValue('');
        } finally {
            setVerifying(false);
        }
    };

    const handleClose = () => {
        setCaptchaData(null);
        setCaptchaValue('');
        setErrorMsg('');
        if (onClose) {
            onClose();
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && !verifying) {
            handleSubmit();
        }
    };

    return (
        <Dialog 
            open={isOpen} 
            className="WafCaptchaDia" 
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                handleClose();
            }}
        >
            <DialogTitle>安全验证</DialogTitle>
            <DialogContent>
                <div className="WafCaptchaContent">
                    <div style={{ marginBottom: '5px', fontSize: '11px', textAlign: 'center', lineHeight: '1.3' }}>
                        请求频繁，需完成验证
                    </div>
                    
                    {loading ? (
                        <div className="WafCaptchaLoading">加载中...</div>
                    ) : captchaData && captchaData.captcha_data ? (
                        <img 
                            src={captchaData.captcha_data} 
                            alt="验证码" 
                            className="WafCaptchaImage"
                            onClick={handleRefresh}
                            title="点击刷新"
                        />
                    ) : (
                        <div className="WafCaptchaLoading">点击刷新获取</div>
                    )}

                    <input 
                        type="text"
                        className="WafCaptchaInput"
                        placeholder="输入验证码"
                        value={captchaValue}
                        onChange={(e) => setCaptchaValue(e.target.value)}
                        onKeyPress={handleKeyPress}
                        disabled={verifying || loading}
                        maxLength={6}
                    />

                    <div className="WafCaptchaTip">
                        点击图片刷新
                    </div>

                    <div className="WafCaptchaError">
                        {errorMsg}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div onClick={handleRefresh} className="WafCaptchaBtn" disabled={loading || verifying}>
                    刷新
                </div>
                <div 
                    onClick={handleSubmit} 
                    className="WafCaptchaBtn primary"
                    disabled={verifying || loading}
                >
                    {verifying ? '验证中...' : '确定'}
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default WafCaptchaDia;
